import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const MultiPaneMenuSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 12V17.5C3.5 18.6046 4.39543 19.5 5.5 19.5H18.5C19.6046 19.5 20.5 18.6046 20.5 17.5V12M3.5 12V6.5C3.5 5.39543 4.39543 4.5 5.5 4.5H12M3.5 12H12M20.5 12V6.5C20.5 5.39543 19.6046 4.5 18.5 4.5H12M20.5 12H12M12 4.5V12" stroke="currentColor" stroke-width="0.85"/>
</svg>

)

const MultiPaneMenuIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        {MultiPaneMenuSvg}
    </SvgIcon>
)

export default MultiPaneMenuIcon